import { TrainerHoursState } from './types';

export const state = (): TrainerHoursState => initialState();

export const initialState = (): TrainerHoursState => ({
  trainerHours: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['date'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [
        'courseName',
        'costCenter',
        'trainerFullName',
        'description',
      ],
    },
  },
});
